var n=(t,r=2)=>(t=t||0,String(t).padStart(r,"0"));export{n as a};
//# sourceMappingURL=chunk.NV2UT64Q.js.map
